"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.extract = void 0;
var ramda_1 = require("ramda");
/**
 * @callback object~filterPredicate
 * @param {String} key
 * @param {Number} keyIndex
 * @param {Array} keyArray
 * @returns {Boolean}
 */
/**
 * Returns a shallow extract of an object.
 * @curry
 * @param {object~filterPredicate} test - The predicate used to filter the object's properties
 * @param {Object} obj - The object to filter
 * @returns {Object}
 */
var filter = ramda_1.curry(function (test, obj) {
    return Object.assign.apply(Object, __spreadArray([
        {}
    ], Object.keys(obj)
        .filter(test)
        .map(function (key) {
        var _a;
        return (_a = {}, _a[key] = obj[key], _a);
    })));
});
/**
 * @type {object~filterPredicate}
 */
var search = function (key) { return function (elem) {
    return (typeof elem !== 'string' && key.match(elem)) || elem === key;
}; };
/**
 * @param {Array.<String|RegExp>} allowed
 * @returns {function(Object): (Object)}
 */
var extract = function (allowed) { return filter(function (key) { return allowed.find(search(key)); }); };
exports.extract = extract;
//# sourceMappingURL=extract.js.map